module.exports = __webpack_public_path__ + "static/media/yellow.8adbc707.jpg";